import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import ApproveModal from "../../Components/Common/ApproveModal";
import ModalInputFile from "../../Components/ModalInputFile";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import { Swiper, SwiperSlide } from "swiper/react";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { api } from "../../config";

import "nouislider/distribute/nouislider.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../store/employee/action";
import { getDepartment, resetDepartmentState } from "../../store/department/action";
import { resetAssetCategoryState, getAssetCategory } from "../../store/assetCategory/action";
import { getAssetTag, addNewAssetTag } from "../../store/assetTag/action";
import { getAssetClass, addNewAssetClass } from "../../store/assetClass/action";
import { getUom, addNewUom } from "../../store/uom/action";
import { getBrand, addNewBrand, resetBrandState } from "../../store/brand/action";
import { getAccAccount, resetAccAccountState } from "../../store/accAccount/action";
import { resetAssetState, getAsset as onGetAssets, addNewAsset as onAddNewAsset, updateAsset as onUpdateAsset, deleteAsset as onDeleteAsset, getAssetLoading, resetAssetCreateState } from "../../store/asset/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../assets/images/users/user-dummy-img.jpg";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import ExportDoc from "../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../store/actions";
SwiperCore.use([FreeMode, Navigation, Thumbs]);

const Asset = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [assetDoc, setAssetDoc] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalTag, setModalTag] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, assets, assetAdded, isAssetCreated, isAssetSuccess, loading, error, employees, employeeLoading, assetCategories, assetCategoryLoading, assetTags, assetTagLoading, companies, companyLoading, clients, clientLoading, departments, departmentLoading, assetClasses, assetClassLoading, uoms, uomLoading, brands, brandLoading, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    assetAdded: state.Asset.assetAdded,
    assets: state.Asset.assets,
    isAssetCreated: state.Asset.isAssetCreated,
    isAssetSuccess: state.Asset.isAssetSuccess,
    loading: state.Asset.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    assetCategories: state.AssetCategory.assetCategories,
    assetCategoryLoading: state.AssetCategory.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    assetTags: state.AssetTag.assetTags,
    assetTagLoading: state.AssetTag.loading,
    assetClasses: state.AssetClass.assetClasses,
    assetClassLoading: state.AssetClass.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    uoms: state.Uom.uoms,
    uomLoading: state.Uom.loading,
    error: state.Asset.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [assetList, setAssetList] = useState([]);
  const [asset, setAsset] = useState([]);
  const [info, setInfo] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [assetTagList, setAssetTagList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [assetClassList, setAssetClassList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [assetFiles, setAssetFiles] = useState([]);
  const [mediaType, setMediaType] = useState("");

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const conditionData = [
    {
      options: [
        { label: "Good", value: "Good" },
        { label: "Partially Damaged", value: "Partially Damaged" },
        { label: "Damaged", value: "Damaged" },
      ],
    },
  ];

  const depreciationData = [
    {
      options: [
        { label: "Straight", value: "Straight" },
        { label: "Decrease", value: "Decrease" },
      ],
    },
  ];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAssets = assets;
      if (type !== "all") {
        filteredAssets = assets.filter((asset) => asset.asset_status.name === type);
      }
      setAssetList(filteredAssets);
    }
  };

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [swiperActiveTab, setSwiperActiveTab] = useState("1");
  const toggleSwiper = (tab) => {
    if (swiperActiveTab !== tab) {
      setSwiperActiveTab(tab);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setAssetList(assets);
  // }, [assets]);

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(resetAssetState());
    dispatch(onGetAssets());
    handleGetAssetCategory(userData?.companyId);
    handleGetBrand(userData?.companyId);
    handleGetAccAccount(userData?.companyId);
    handleGetUOM(userData?.companyId);
    handleGetAssetTag(userData?.companyId);
    handleGetEmployee(userData?.companyId);
    handleGetAssetClass(userData?.companyId);
    handleGetDepartment(userData?.companyId);
  }, []);

  const handleGetAssetCategory = (id) => {
    dispatch(resetAssetCategoryState());
    dispatch(getAssetCategory({ companyId: id, status: 2 }));
  };

  const handleGetBrand = (companyId) => {
    dispatch(resetBrandState());
    dispatch(getBrand({ companyId: companyId, status: 2 }));
  };

  const handleGetUOM = (companyId) => {
    dispatch(getUom({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleGetAssetTag = (companyId) => {
    dispatch(getAssetTag({ companyId: companyId, status: 2 }));
  };

  const handleGetEmployee = (companyId) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ type: "referral", status: 2, companyId: companyId }));
  };

  const handleGetAssetClass = (companyId) => {
    dispatch(getAssetClass({ companyId: companyId, status: 2 }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(assets)) {
      let filteredAssets = assets;
      if (activeTypeTab !== "all") {
        filteredAssets = assets.filter((asset) => asset.asset_status.name === activeTypeTab);
      }
      setAssetList(filteredAssets.map((el) => ({ ...el, isChecked: false })));
      let obj = assets.length > 0 ? assets[assets.length - 1] : null;
      if (obj) {
        setInfo(obj);
        setLocationCord([obj.latitude, obj.longitude]);
      }
    }
  }, [assets]);

  useEffect(() => {
    // let dataDoc = [
    //   {
    //     id: "name",
    //     label: "Nama",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "acquisitionat",
    //     label: "Penerimaan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "condition",
    //     label: "Kondisi",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "price",
    //     label: "Harga",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_holder",
    //     label: "PIC",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "depreciation",
    //     label: "Depresiasi",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "quantity",
    //     label: "Qty",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "description",
    //     label: "Keterangan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_category",
    //     label: "Kategori",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_class",
    //     label: "Kelas",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_brand",
    //     label: "Merek",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_client",
    //     label: "Grup Usaha",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_company",
    //     label: "Perusahaan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_department",
    //     label: "Departemen",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "asset_status",
    //     label: "Status",
    //     isSelected: true,
    //     data: []
    //   },
    // ]

    let dataDoc = [
      // {
      //   id: "?",
      //   label: "Penjual",
      //   isSelected: true,
      //   data: []
      // },
      // {
      //   id: "?",
      //   label: "Pembeli",
      //   isSelected: true,
      //   data: []
      // },
      {
        id: "asset_category",
        label: "Status",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "Luas",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "HGB",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "AJB",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "SHM",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "NIB",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "PBB",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "IMB",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "Copy/Asli",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "Status Berkas",
        isSelected: true,
        data: [],
      },
      {
        id: "?",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (assetList.length > 0) {
      assetList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "asset_status" || doc.id === "asset_uom" || doc.id === "asset_category" || doc.id === "asset_class" || doc.id === "asset_brand" || doc.id === "asset_client" || doc.id === "asset_company" || doc.id === "asset_department") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "acquisitionat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "price" || doc.id === "quantity") {
                doc.data.push(currencyFormat(value));
              } else if (doc.id === "asset_holder") {
                doc.data.push(value.length > 0 ? value[0].asset_holder_user?.name ?? "-" : "-");
              } else {
                doc.data.push(value);
              }
            }
          });
        }
      });
    }

    setAssetDoc(dataDoc);
  }, [assetList]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(assetTags)) {
      var data = [];
      var opt = [];
      assetTags.forEach((item, key) => {
        const tag_name = item.name;
        const id = item.id;
        var obj = { label: tag_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAssetTagList(data);
    }
  }, [assetTags]);

  useEffect(() => {
    if (!isEmpty(uoms)) {
      var data = [];
      var opt = [];
      uoms.forEach((item, key) => {
        const uom_name = item.name;
        const id = item.id;
        var obj = { label: uom_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUomList(data);
    }
  }, [uoms]);

  useEffect(() => {
    if (!isEmpty(assetClasses)) {
      var data = [];
      var opt = [];
      assetClasses.forEach((item, key) => {
        const class_name = item.name;
        const id = item.id;
        var obj = { label: class_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAssetClassList(data);
    }
  }, [assetClasses]);

  useEffect(() => {
    if (!isEmpty(assetCategories)) {
      var data = [];
      var opt = [];
      assetCategories.forEach((item, key) => {
        const category_name = item.name;
        const id = item.id;
        var obj = { label: category_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCategoryList(data);
    }
  }, [assetCategories]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.userId;
        const taskListId = item.taskListId;
        const positionId = item.positionId;
        const position_name = item?.employee_user?.user_department && item?.employee_user?.user_department?.name ? item?.employee_user?.user_department?.name : "Not set";
        var obj = {
          label: name + " - " + position_name,
          value: id,
          taskListId: taskListId,
          positionId: positionId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(brands)) {
      var brandData = [];
      var opt = [];
      brands.forEach((item, key) => {
        const brand_name = item.name;
        const id = item.id;
        var obj = { label: brand_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      brandData.push(option);
      setBrandList(brandData);
    }
  }, [brands]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const onClickDelete = (asset) => {
    setAsset(asset);
    setDeleteModal(true);
  };

  const onClickApprove = (asset) => {
    setAsset(asset);
    setApproveModal(true);
  };

  const handleDeleteAsset = () => {
    if (asset) {
      dispatch(onDeleteAsset(asset));
      setDeleteModal(false);
    }
  };

  const handleApproveAsset = () => {
    if (asset) {
      asset.setApprove = true;
      dispatch(onUpdateAsset(asset));
      setApproveModal(false);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAsset(null);
      // setDepartmentList([]);
      // setCompanyList([]);
      // setAssetFiles([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTag = useCallback(() => {
    if (modalTag) {
      setModalTag(false);
    } else {
      setModalTag(true);
    }
  }, [modalTag]);

  const validationTag = useFormik({
    enableReinitialize: true,
    initialValues: {
      tag_name: "",
    },
    validationSchema: Yup.object({
      tag_name: Yup.string().required("Please enter tag name").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(addNewAssetTag({ tag_name: values.tag_name }));
      validationTag.resetForm();
      toggleTag();
    },
  });

  const handleAssetClick = useCallback(
    (arg) => {
      const asset = arg;

      let tag = [];

      if (asset.tag && asset.tag.length) {
        asset.tag.forEach((item) => {
          const tag_name = item.label;
          const id = item.value;
          var obj = { label: tag_name, value: id };
          tag.push(obj);
        });
      }
      let files = [];
      for (const f of asset.asset_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setAssetFiles(files);

      let pic = [];

      if (asset.asset_holder && asset.asset_holder.length) {
        asset.asset_holder.forEach((item) => {
          const name = item.asset_holder_user && item.asset_holder_user.name;
          const id = item.userId;
          var obj = { label: name, value: id };
          pic.push(obj);
        });
      }

      setAsset({
        id: asset.id,
        asset_holder: pic,
        name: asset.name,
        description: asset.description,
        price: asset.price,
        quantity: asset.quantity,
        njop: asset.njop,
        price_depreciation: asset.price_depreciation,
        price_accumulation: asset.price_accumulation,
        age: asset.age,
        percentage: asset.percentage,
        latitude: asset.latitude,
        longitude: asset.longitude,
        uom: {
          label: asset.asset_uom.name,
          value: asset.asset_uom.id,
        },
        condition: asset.condition && {
          label: asset.condition,
          value: asset.condition,
        },
        account: asset.asset_acc_account && {
          label: asset.asset_acc_account.name,
          value: asset.asset_acc_account.id,
        },
        accountPurchase: asset.asset_acc_purchase && {
          label: asset.asset_acc_purchase.name,
          value: asset.asset_acc_purchase.id,
        },
        accountDepreciation: asset.asset_acc_depreciation && {
          label: asset.asset_acc_depreciation.name,
          value: asset.asset_acc_depreciation.id,
        },
        barcode: asset.barcode,
        brand: asset.asset_brand && {
          label: asset.asset_brand.name,
          value: asset.asset_brand.id,
        },
        class: asset.asset_class && {
          label: asset.asset_class.name,
          value: asset.asset_class.id,
        },
        company: {
          label: asset.asset_company.name,
          value: asset.asset_company.id,
        },
        client: asset.asset_client && {
          label: asset.asset_client.name,
          value: asset.asset_client.id,
        },
        department: asset.asset_department &&
          asset.asset_department.name && {
            label: asset.asset_department.name,
            value: asset.asset_department.id,
          },
        category: asset.asset_category &&
          asset.asset_category.name && {
            label: asset.asset_category.name,
            value: asset.asset_category.id,
          },
        tag: tag,
        acquisitionat: asset.acquisitionat,
        depreciation: asset.depreciation && {
          label: asset.depreciation,
          value: asset.depreciation,
        },
        image: asset.image,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = assetList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAssetList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = assetList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAssetList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      setLocationCord([data.latitude, data.longitude]);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAsset") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAssetClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAsset") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveAsset") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                  onClick={() => {
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                </button>
              )}
            </div>
          );
        },
        id: "#",
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (data) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1 align-items-center">{data.row.original.image && <img src={data.row.original.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${data.row.original.image}`} alt="" className="img-fluid d-block" style={{ height: "45px" }} />}</div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <Link to="/apps-ecommerce-asset-details" className="text-dark">
                    {data.row.original.name}
                  </Link>
                </h5>
                <p className="text-muted mb-0">
                  <span className="fw-medium">{data.row.original.asset_category && data.row.original.asset_category.category_name}</span>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Penerimaan",
        accessor: "acquisitionat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.acquisitionat);
        },
      },
      {
        Header: "Kondisi",
        accessor: "condition",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "Good":
              return <span className="badge text-uppercase badge-soft-success"> {cell.value} </span>;
            case "Damaged":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            case "Partially Damaged":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
      {
        Header: "Harga",
        accessor: "price",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.price)}</span>;
        },
      },
      {
        Header: "PIC",
        accessor: "asset_holder",
        filterable: false,
        Cell: (cell) => {
          const assigned = cell.value.map((item) => (item.asset_holder_user ? item.asset_holder_user : item));
          return (
            <React.Fragment>
              <div className="avatar-group">
                {assigned.map((item, index) => (
                  <Link key={item.id + "-assigned"} to="#" className="avatar-group-item">
                    {item.employee_image && item.employee_image.filename ? (
                      <img id={"image" + item.id + "-assigned"} src={`${api.MEDIA_URL}/media/${item.employee_image.filename}`} alt="" className="rounded-circle avatar-xs" />
                    ) : (
                      <div id={"image" + item.id + "-assigned"} className="flex-shrink-0 avatar-xs">
                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.name && item.name.charAt(0)}</div>
                      </div>
                    )}
                    <UncontrolledTooltip placement="top" target={"image" + item.id + "-assigned"}>
                      {item.name && item.name}
                    </UncontrolledTooltip>
                  </Link>
                ))}
              </div>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Status",
        accessor: "asset_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [assetList, handleAssetClick, userType, userRole, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = assetList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAssetList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => assetList, [assetList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAssets(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAssetList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetAssetState());
    dispatch(onGetAssets());
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (asset && asset.id) || 0,
      client: (asset && asset.client) || clientSelected,
      company: (asset && asset.company) || companySelected,
      name: (asset && asset.name) ?? "",
      description: (asset && asset.description) ?? "",
      price: (asset && asset.price) || 0,
      quantity: (asset && asset.quantity) || 0,
      njop: (asset && asset.njop) || 0,
      price_depreciation: (asset && asset.price_depreciation) || 0,
      price_accumulation: (asset && asset.price_accumulation) || 0,
      longitude: (asset && asset.longitude) ?? "",
      latitude: (asset && asset.latitude) ?? "",
      age: (asset && asset.age) || 0,
      percentage: (asset && asset.percentage) || 0,
      sku: (asset && asset.sku) ?? "",
      barcode: (asset && asset.barcode) ?? "",
      brand: (asset && asset.brand) ?? "",
      department: asset && asset.department,
      category: asset && asset.category,
      uom: asset && asset.uom,
      account: (asset && asset.account) ?? "",
      accountPurchase: (asset && asset.accountPurchase) ?? "",
      accountDepreciation: (asset && asset.accountDepreciation) ?? "",
      class: asset && asset.class,
      tag: asset && asset.tag,
      asset_holder: asset && asset.asset_holder,
      condition: asset && asset.condition,
      acquisitionat: asset && asset.acquisitionat,
      depreciation: (asset && asset.depreciation) || depreciationData[0].options[0],
      image: (asset && asset.image) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter asset name").nullable(true),
      //brand: Yup.object().required("Please enter brand name").nullable(true),
      uom: Yup.object().required("Please enter unit").nullable(true),
      class: Yup.object().required("Please enter class").nullable(true),
      price: Yup.number().required("Please enter price number").nullable(true),
      //barcode: Yup.string().required("Please enter barcode").nullable(true),
      company: Yup.object().required("Please enter company").nullable(true),
      asset_holder: Yup.array()
        .min(1, "Pick at least 1 employee")
        .of(
          Yup.object().shape({
            label: Yup.string().required().nullable(true),
            value: Yup.string().required().nullable(true),
          })
        ),
      condition: Yup.object().required("Please enter asset condition").nullable(true),
      department: Yup.object().required("Please enter department").nullable(true),
      category: Yup.object().required("Please enter category").nullable(true),
      // account: Yup.object().required("Please enter asset account").nullable(true),
      // accountPurchase: Yup.object().required("Please enter asset credited account").nullable(true),
      // accountDepreciation: Yup.object().required("Please enter asset credited account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAssetLoading());
      if (isEdit) {
        const editAsset = {
          id: asset ? asset.id : 0,
          name: values.name,
          brand: values.brand.value,
          description: values.description,
          longitude: values.longitude,
          latitude: values.latitude,
          uom: values.uom.value,
          classId: values.class.value,
          acquisitionat: values.acquisitionat,
          depreciation: values.depreciation.value,
          barcode: values.barcode,
          price: values.price,
          quantity: values.quantity,
          njop: values.njop,
          price_depreciation: values.price_depreciation,
          price_accumulation: values.price_accumulation,
          age: values.age,
          percentage: values.percentage,
          categoryId: values.category.value,
          companyId: values.company.value,
          clientId: values.client.value,
          departmentId: values.department.value,
          accId: values.account.value,
          accPurchaseId: values.accountPurchase.value,
          accDepreciationId: values.accountDepreciation.value,
          tag: JSON.stringify(values.tag),
          asset_holder: JSON.stringify(values.asset_holder),
          condition: values.condition.value,
          files: assetFiles.length > 0 ? assetFiles : [],
          image: values.image,
        };
        dispatch(onUpdateAsset(editAsset));
      } else {
        const addAsset = {
          name: values.name,
          brand: values.brand.value,
          description: values.description,
          longitude: values.longitude,
          latitude: values.latitude,
          uom: values.uom.value,
          classId: values.class.value,
          acquisitionat: values.acquisitionat,
          depreciation: values.depreciation.value,
          barcode: values.barcode,
          price: values.price,
          quantity: values.quantity,
          njop: values.njop,
          price_depreciation: values.price_depreciation,
          price_accumulation: values.price_accumulation,
          age: values.age,
          percentage: values.percentage,
          categoryId: values.category.value,
          companyId: values.company.value,
          clientId: values.client.value,
          departmentId: values.department.value,
          accId: values.account.value,
          accPurchaseId: values.accountPurchase.value,
          accDepreciationId: values.accountDepreciation.value,
          tag: JSON.stringify(values.tag),
          asset_holder: JSON.stringify(values.asset_holder),
          condition: values.condition.value,
          files: assetFiles.length > 0 ? assetFiles : [],
          image: values.image,
        };
        dispatch(onAddNewAsset(addAsset));
      }
      validation.resetForm();
      toggle();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAsset(element.value));
    });
    checkall.checked = false;
  };

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  document.title = "Akuisisi | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={assetList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAsset} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={asset && asset.name ? asset.name : ""} show={approveModal} onApproveClick={handleApproveAsset} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Aset" pageTitle="Akuisisi" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAsset") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={assetDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "ms-1 btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteAsset") !== -1 ? "ms-1 btn btn-soft-danger" : "ms-1 btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={9}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i> SEMUA AKUISISI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">
                      <strong>{rows.length}</strong> Data
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Aset" : "Tambah Aset"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Row>
                        <Col lg={8}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="name">
                              Nama Aset
                            </Label>
                            <Input type="text" className="form-control" id="name" placeholder="Isi Nama" name="name" value={validation.values.name ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.name}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label>Keterangan</Label>
                            <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan" name="description" rows={4} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.description}
                              </small>
                            )}
                          </div>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3 d-flex justify-content-between">
                                <Label htmlFor="image" className="form-label">
                                  Gambar
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    setMediaType("image");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                </button>
                              </div>
                              {validation.values.image !== "" ? (
                                <div className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="me-2">
                                      <img src={validation.values.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{validation.values.image}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          validation.setFieldValue("image", "");
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3 d-flex justify-content-between">
                                <Label htmlFor="taskFiles" className="form-label me-3">
                                  Dokumen Aset
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    setMediaType("files");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                </button>
                              </div>
                              {assetFiles.map((assetFile, i) => {
                                if (assetFile.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <div key={i} className="border-bottom mb-3">
                                      <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="me-2">
                                          <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                        </div>
                                        <div className="text-truncate">{assetFile.originalname}</div>
                                        <div>
                                          <Link
                                            to="#"
                                            className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                            onClick={(e) => {
                                              handleDeleteFile(assetFile);
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </Col>
                          </Row>
                          <h5 className="card-title mb-3 pb-2 mt-3 border-bottom">Aset Detail</h5>
                          <Row>
                            <Col sm={4}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="price">
                                  Nilai Perolehan Aset
                                </label>
                                <div className="input-group mb-3">
                                  <span className="input-group-text" id="price-addon">
                                    Rp
                                  </span>
                                  <Input type="number" className="form-control" id="price" placeholder="Enter price" name="price" value={validation.values.price || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.price && validation.errors.price ? true : false} />
                                  {validation.touched.price && validation.errors.price && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.price}
                                    </small>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col sm={4}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="njop">
                                  Harga Jual Aset
                                </label>
                                <div className="input-group mb-3">
                                  <span className="input-group-text" id="njop-addon">
                                    Rp
                                  </span>
                                  <Input type="number" className="form-control" id="njop" placeholder="Enter njop" name="njop" value={validation.values.njop || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.njop && validation.errors.njop ? true : false} />
                                  {validation.touched.njop && validation.errors.njop && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.njop}
                                    </small>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col sm={4}>
                              <div className="mb-3">
                                <label htmlFor="datepicker-publish-input" className="form-label">
                                  Tanggal Perolehan
                                </label>
                                <Flatpickr
                                  name="date-picker"
                                  className="form-control"
                                  placeholder="Pilih Tanggal"
                                  options={{
                                    enableTime: false,
                                    time_24hr: false,
                                    dateFormat: "Y/m/d",
                                  }}
                                  value={validation.values.acquisitionat ?? ""}
                                  onChange={(obj, str) => {
                                    validation.setFieldValue("acquisitionat", str);
                                  }}
                                />
                                {validation.touched.acquisitionat && validation.errors.acquisitionat && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.acquisitionat}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={4}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="barcode">
                                  Barcode
                                </label>
                                <Input name="barcode" id="barcode" disabled={true} className="form-control" placeholder="Automation" type="text" value={validation.values.barcode} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={validation.touched.barcode && validation.errors.barcode ? true : false} />
                                {validation.touched.barcode && validation.errors.barcode && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.barcode}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="mb-3">
                                <Label htmlFor="choices-publish-condition-input" className="form-label">
                                  Kondisi Aset
                                </Label>
                                <Select
                                  name="condition"
                                  placeholder="Pilih Kondisi"
                                  value={validation.values.condition}
                                  onChange={(e) => {
                                    validation.setFieldValue("condition", e);
                                  }}
                                  options={conditionData}
                                ></Select>
                                {validation.touched.condition && validation.errors.condition && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.condition}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="weight">
                                  Satuan Ukur
                                </label>
                                <Select
                                  name="uom"
                                  placeholder="Pilih Satuan"
                                  value={validation.values.uom}
                                  onChange={(e) => {
                                    validation.setFieldValue("uom", e);
                                  }}
                                  options={uomList}
                                ></Select>
                                {validation.touched.uom && validation.errors.uom && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.uom}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={2}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="quantity">
                                  Luas
                                </label>
                                <Input type="number" className="form-control" id="quantity" placeholder="Enter quantity" name="quantity" value={validation.values.quantity || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.quantity && validation.errors.quantity ? true : false} />
                                {validation.touched.quantity && validation.errors.quantity && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.quantity}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>

                          <h5 className="card-title mb-3 pb-2 mt-3 border-bottom">Lokasi Aset</h5>
                          <Row>
                            <Col sm={6}>
                              <div className="mb-3">
                                <Label htmlFor="latitude-field" className="form-label">
                                  Latitude
                                </Label>
                                <Input name="latitude" id="latitude-field" className="form-control" placeholder="Isi Latitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.latitude ?? ""} />
                              </div>
                            </Col>
                            <Col sm={6}>
                              <div className="mb-3">
                                <Label htmlFor="longitude-field" className="form-label">
                                  Longitude
                                </Label>
                                <Input name="longitude" id="longitude-field" className="form-control" placeholder="Isi Longitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longitude ?? ""} />
                              </div>
                            </Col>
                          </Row>
                          <h5 className="card-title mb-3 pb-2 mt-3 border-bottom">Akuntansi dan Depresiasi</h5>
                          <Row>
                            <Col sm={6}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="account">
                                  Akun Aset
                                </label>
                                <Select
                                  name="account"
                                  value={validation.values.account}
                                  placeholder="Pilih Akun"
                                  onChange={(e) => {
                                    validation.setFieldValue("account", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.account && validation.errors.account && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.account}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={6}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="accountPurchase">
                                  Dikreditkan pada Akun
                                </label>
                                <Select
                                  name="accountPurchase"
                                  value={validation.values.accountPurchase}
                                  placeholder="Pilih Akun"
                                  onChange={(e) => {
                                    validation.setFieldValue("accountPurchase", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.accountPurchase && validation.errors.accountPurchase && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.accountPurchase}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="age">
                                  Umur Ekonomis
                                </label>
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="age"
                                  placeholder="Enter umur"
                                  name="age"
                                  value={validation.values.age}
                                  onFocus={(e) => e.target.select()}
                                  onBlur={validation.handleBlur}
                                  onChange={(e) => {
                                    let val = !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0;
                                    if (validation.values.depreciation.value === "Straight") {
                                      validation.setFieldValue("percentage", parseFloat(100 / val));
                                      validation.setFieldValue("price_depreciation", parseFloat(100 / e.target.value / 100) * validation.values.price);
                                    } else {
                                      validation.setFieldValue("percentage", parseFloat((100 / val) * 2));
                                      validation.setFieldValue("price_depreciation", parseFloat(((100 / e.target.value) * 2) / 100) * validation.values.price);
                                    }
                                    validation.setFieldValue("age", val);
                                  }}
                                  invalid={validation.touched.age && validation.errors.age ? true : false}
                                />
                                {validation.touched.age && validation.errors.age && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.age}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={4}>
                              <div className="mb-3">
                                <Label htmlFor="choices-publish-condition-input" className="form-label">
                                  Metode Penyusutan
                                </Label>
                                <Select
                                  name="depreciation"
                                  placeholder="Select metode"
                                  value={validation.values.depreciation}
                                  onChange={(e) => {
                                    validation.setFieldValue("depreciation", e);
                                    if (e.value === "Straight") {
                                      validation.setFieldValue("percentage", parseFloat(100 / validation.values.age));
                                      validation.setFieldValue("price_depreciation", parseFloat(100 / validation.values.age / 100) * validation.values.price);
                                    } else {
                                      validation.setFieldValue("percentage", parseFloat((100 / validation.values.age) * 2));
                                      validation.setFieldValue("price_depreciation", parseFloat(((100 / validation.values.age) * 2) / 100) * validation.values.price);
                                    }
                                  }}
                                  options={depreciationData}
                                ></Select>
                                {validation.touched.depreciation && validation.errors.depreciation && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.depreciation}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={5}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="accountDepreciation">
                                  Akun Penyusutan
                                </label>
                                <Select
                                  name="accountDepreciation"
                                  value={validation.values.accountDepreciation}
                                  placeholder="Pilih Akun"
                                  onChange={(e) => {
                                    validation.setFieldValue("accountDepreciation", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.accountDepreciation && validation.errors.accountDepreciation && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.accountDepreciation}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={3}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="percentage">
                                  %
                                </label>
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="percentage"
                                  placeholder="Enter amount"
                                  name="percentage"
                                  value={validation.values.percentage}
                                  onFocus={(e) => e.target.select()}
                                  onBlur={validation.handleBlur}
                                  onChange={(e) => {
                                    let val = !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0;
                                    validation.setFieldValue("percentage", val);
                                    validation.setFieldValue("price_depreciation", parseFloat((e.target.value / 100) * validation.values.price));
                                  }}
                                  invalid={validation.touched.percentage && validation.errors.percentage ? true : false}
                                />
                                {validation.touched.percentage && validation.errors.percentage && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.percentage}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={4}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="price_depreciation">
                                  Beban Penyusutan
                                </label>
                                <Input type="number" className="form-control" id="price_depreciation" placeholder="Enter amount" name="price_depreciation" value={validation.values.price_depreciation || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.price_depreciation && validation.errors.price_depreciation ? true : false} />
                                {validation.touched.price_depreciation && validation.errors.price_depreciation && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.price_depreciation}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col sm={5}>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="price_accumulation">
                                  Akumulasi Beban Penyusutan
                                </label>
                                <Input type="number" className="form-control" id="price_accumulation" placeholder="Enter amount" name="price_accumulation" value={validation.values.price_accumulation || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.price_accumulation && validation.errors.price_accumulation ? true : false} />
                                {validation.touched.price_accumulation && validation.errors.price_accumulation && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.price_accumulation}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={4}>
                          <Card>
                            <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                              <h5 className="card-title mb-0">Identitas Aset</h5>
                            </CardHeader>
                            <CardBody className="row">
                              <div className="mb-3">
                                <Label htmlFor="client-field" className="form-label">
                                  Grup Usaha&nbsp;
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </Label>
                                <Select
                                  name="client"
                                  value={validation.values.client}
                                  isDisabled={userType === "admin" || (userType === "client") === true ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    validation.setFieldValue("client", e);
                                  }}
                                  options={clientList}
                                ></Select>
                              </div>

                              <div className="mb-3">
                                <Label htmlFor="company-field" className="form-label">
                                  Perusahaan&nbsp;
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </Label>
                                <Select
                                  name="company"
                                  value={validation.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setBranchSelect(null));
                                    dispatch(setCompanySelect(e));
                                    validation.setFieldValue("company", e);
                                    handleGetAssetCategory(e.value);
                                    handleGetBrand(e.value);
                                    handleGetAccAccount(e.value);
                                    handleGetUOM(e.value);
                                    handleGetAssetTag(e.value);
                                    handleGetEmployee(e.value);
                                    handleGetAssetClass(e.value);
                                    handleGetDepartment(e.value);
                                  }}
                                  options={companyList}
                                ></Select>
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="department" className="form-label">
                                  Department / Cost Center
                                  {departmentLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </Label>
                                <Select
                                  name="department"
                                  value={validation.values.department}
                                  placeholder="Pilih Departemen"
                                  onChange={(e) => {
                                    validation.setFieldValue("department", e);
                                  }}
                                  options={departmentList}
                                  invalid={validation.touched.department && validation.errors.department ? true : false}
                                ></Select>
                                {validation.touched.department && validation.errors.department ? (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.department}
                                  </small>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="company">
                                  PIC / Users
                                </label>
                                <Select
                                  name="asset_holder"
                                  value={validation.values.asset_holder}
                                  placeholder="Pilih Karyawan"
                                  isMulti
                                  onChange={(opt, { option }) => {
                                    let newOpts = opt;
                                    if (option && option.value === "all") {
                                      let filteredOptions = clone(employeeList);
                                      filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                      newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                    }
                                    validation.setFieldValue("asset_holder", newOpts);
                                  }}
                                  options={employeeList}
                                  noOptionsMessage={(e) => "Type Employee to get option"}
                                  invalid={validation.touched.asset_holder && validation.errors.asset_holder ? true : false}
                                ></Select>
                                {validation.touched.asset_holder && validation.errors.asset_holder ? (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.asset_holder}
                                  </small>
                                ) : null}
                              </div>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                              <h5 className="card-title mb-0">Kategori</h5>
                            </CardHeader>
                            <CardBody className="row">
                              <div className="mb-3">
                                <label className="mb-2">Kategori Aset</label>
                                <Select
                                  name="category"
                                  value={validation.values.category}
                                  placeholder="Pilih Kategori"
                                  onChange={(e) => {
                                    validation.setFieldValue("category", e);
                                  }}
                                  options={categoryList}
                                ></Select>
                                {validation.touched.category && validation.errors.category && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.category}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="brand">
                                  Merek
                                </label>
                                <Select
                                  name="brand"
                                  value={validation.values.brand}
                                  placeholder="Pilih Merek"
                                  onChange={(e) => {
                                    validation.setFieldValue("brand", e);
                                  }}
                                  options={brandList}
                                ></Select>
                                {validation.touched.brand && validation.errors.brand && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.brand}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="mb-2"> Kelas Aset</label>
                                <Select
                                  name="class"
                                  value={validation.values.class}
                                  placeholder="Pilih Aset Kelas"
                                  onChange={(e) => {
                                    validation.setFieldValue("class", e);
                                  }}
                                  options={assetClassList}
                                ></Select>
                                {validation.touched.class && validation.errors.class && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.class}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <p className="mb-0">
                                  <Link to="#" className="float-end text-decoration-underline" onClick={() => toggleTag()}>
                                    Tambah
                                  </Link>
                                  <label>Aset Tag</label>
                                </p>
                                <Select
                                  name="tag"
                                  value={validation.values.tag}
                                  placeholder="Pilih Aset Tag"
                                  isMulti
                                  onChange={(opt, { option }) => {
                                    let newOpts = opt;
                                    if (option && option.value === "all") {
                                      let filteredOptions = clone(assetTagList);
                                      filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                      newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                    }
                                    validation.setFieldValue("tag", newOpts);
                                  }}
                                  options={assetTagList}
                                ></Select>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setAssetFiles([]);
                          }}
                        >
                          {" "}
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update Data" : "Simpan Data"}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalTag" isOpen={modalTag} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleTag}>
                    Tambah Tag Aset
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationTag.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="tag_name-field" className="form-label">
                            Tag Name
                          </Label>
                          <Input name="tag_name" id="tag_name-field" className="form-control" placeholder="Enter Tag Name" type="text" onChange={validationTag.handleChange} onBlur={validationTag.handleBlur} invalid={validationTag.touched.tag_name && validationTag.errors.tag_name ? true : false} />
                          {validationTag.touched.tag_name && validationTag.errors.tag_name ? <FormFeedback type="invalid">{validationTag.errors.tag_name}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalTag(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Add Asset Tag</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={3}>
            <Card>
              <CardBody className="text-center">
                <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                  <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={locationCord}>
                    <Popup>{info.branch_branch && info.branch_branch.name ? info.branch_branch.name : "-"}</Popup>
                  </Marker>
                </MapContainer>
              </CardBody>
              <h6 className="mb-3 ms-3 fw-semibold text-uppercase">Detail Media</h6>
              <div className="card-body mb-0">
                <div className="asset-img-slider mb-3">
                  <Swiper navigation={true} thumbs={{ swiper: thumbsSwiper }} className="swiper asset-thumbnail-slider p-2 rounded bg-light">
                    <div className="swiper-wrapper">
                      {(info.asset_file || []).map((f, i) => {
                        return (
                          <SwiperSlide key={i}>
                            <img src={`${api.MEDIA_URL}/media/${f.filename}`} alt="" className="img-fluid d-block" />
                          </SwiperSlide>
                        );
                      })}
                    </div>
                  </Swiper>
                  <div className="asset-nav-slider mt-2">
                    <Swiper onSwiper={setThumbsSwiper} slidesPerView={4} freeMode={true} watchSlidesProgress={true} spaceBetween={10} className="swiper asset-nav-slider mt-2 overflow-hidden">
                      <div className="swiper-wrapper">
                        {info.asset_file &&
                          info.asset_file.length > 1 &&
                          info.asset_file.map((f, i) => {
                            return (
                              <SwiperSlide key={i} className="rounded">
                                <div className="nav-slide-item">
                                  <img src={`${api.MEDIA_URL}/media/${f.filename}`} alt="" className="img-fluid d-block rounded" />
                                </div>
                              </SwiperSlide>
                            );
                          })}
                      </div>
                    </Swiper>
                  </div>
                </div>
                <h6 className="mb-3 fw-semibold text-uppercase">Detail Aset</h6>
                <table className="table table-responsive table-striped">
                  <tbody>
                    <tr>
                      <td className="p-2">Tags</td>
                      <td className="p-2">
                        <div className="hstack flex-wrap gap-2 fs-15">
                          {(info.tag || []).map((o, i) => (
                            <div key={i} className="badge fw-medium badge-soft-info">
                              {o.label}
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2">Perusahaan</td>
                      <td className="p-2">{info.asset_company && info.asset_company.name}</td>
                    </tr>
                    <tr>
                      <td className="p-2">Departemen</td>
                      <td className="p-2">{info.asset_department && info.asset_department.name}</td>
                    </tr>
                    <tr>
                      <td className="p-2">Kategori</td>
                      <td className="p-2">{info.asset_category && info.asset_category.name}</td>
                    </tr>
                    <tr>
                      <td className="p-2">Golongan</td>
                      <td className="p-2">{info.asset_class && info.asset_class.name}</td>
                    </tr>
                    <tr>
                      <td className="p-2">Merk</td>
                      <td className="p-2">{info.asset_brand && info.asset_brand.name}</td>
                    </tr>
                    <tr>
                      <td className="p-2">PIC</td>
                      <td className="p-2">
                        {(info.asset_holder || []).map((o, i) => (
                          <p key={i} className="mb-1">
                            {o.asset_holder_user && o.asset_holder_user.name}
                          </p>
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2">Barcode</td>
                      <td className="p-2">{info.barcode}</td>
                    </tr>
                    <tr>
                      <td className="p2">Dibuat Oleh</td>
                      <td className="p2">{info.asset_createdby && info.asset_createdby.name ? info.asset_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                    </tr>
                    <tr>
                      <td className="p2">Diedit Oleh</td>
                      <td className="p2">{info.asset_updatedby && info.asset_updatedby.name ? info.asset_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                    </tr>
                    <tr>
                      <td className="p2">Approved By</td>
                      <td className="p2">{info.asset_approvedby && info.asset_approvedby.name ? info.asset_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Asset;
